import owd from 'owd/owd';
import random from 'owd/utils/random';
import br from 'owd/utils/browser';
import 'lib/jquery-inview';

export default class Inview extends owd.Component {
	init() {
		this.context = [this.$element];
		this.delay = this.$element.data('inview-delay');

		if (this.delay == 'random') {
			this.delay = random.int(0, 300);
		} else if (isNaN(parseInt(this.delay))) {
			this.delay = 0;
		} else {
			this.delay = parseInt(this.delay);
		}

		if (this.$element.data('inview').length) {
			this.context.push(
				this.$element.find(this.$element.data('inview'))
			);
		}

		if (br.isIe()) {
			$('html').addClass('ie');
		}

		this.initInview();
		this.bind();
	}

	initInview() {
		this.context.forEach(($context) => {
			let ratio = 1 / 10;

			if ($context.data('inview-ratio') !== undefined) {
				ratio = $context.data('inview-ratio');
			}

			$context.each((index, item) => {
				const $item = $(item);

				if (window.matchMedia('(max-width: 1024px)').matches || Modernizr.touch) {
					// no inview on mobile, please!
					$item.addClass('inview-visible');
				} else {
					if ($item.offset().top < this.dom.$window.scrollTop()) {
						$item.addClass('inview-visible');
						$item.data('inview.isActive', true);
					}

					$item.inview({
						ratio: ratio
					}, (e, dir) => {
						if ($item.data('inview.isActive') !== true && $item[0] === e.target) {
							this.timeout = setTimeout(() => {
								this.timeout = undefined;
								$item.addClass('inview-visible');
								$item.data('inview.isActive', true);

							}, this.delay);
						}
					}, (e, dir) => {
						if (!this.$element.is('[data-inview-prevent-once]')) {
							if (dir == -1 && $item[0] === e.target) {
								if (this.timeout !== undefined) {
									clearTimeout(this.timeout);
									this.timeout = undefined;
								}

								$item.removeClass('inview-visible');
								$item.data('inview.isActive', false);
							}
						}
					});
				}
			});

		});
	}

	bind() {
		this.on('load ajaxload domready', this.dom.$window, (e) => {
			this.context.forEach(($context) => {
				$context.trigger('inview-recalc');
			});

			setTimeout(() => {
				this.dom.$window.trigger('inview-recalc');
			});
		});

		this.on('owd.tick', this.dom.$body, () => {
			setTimeout(() => {
				$(window).trigger('inview-recalc');
			});
		});
	}

	destroy() {
		this.context.forEach(($context) => {
			$context.trigger('inview-destroy');
		});
		super.destroy();
	}
}

owd.registerComponent('inview', {
	component: Inview
});
